<template>
  <video :src="require(`@/assets/videos/${video}`)" autoplay muted loop></video>
</template>

<script>
export default {
  props: {
    video: String
  }
};
</script>

<style lang="scss" scoped>
video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  object-position: center;
  position:fixed;
  top:0;
  left:0;
}
</style>